import React, { Component } from "react";
import Form from "react-jsonschema-form";
import {Button ,Well,ButtonGroup,Glyphicon,ToggleButtonGroup,ToggleButton,ControlLabel,FormGroup,FormControl,HelpBlock,InputGroup} from "react-bootstrap";

import {ActionsDisplay} from "./ActionsDisplay"
import ActionCreate from './ActionCreate'
import ReactDragList from 'react-drag-list'
import Moment from 'react-moment';
import moment from "moment"

/*
0:
address: 1
channel: 0
ctrlType: "RELAY PACK"
dest: "PAGER_ALTIOM"
id: 0
name: "Relay A1 Channel 1"
outputHandler: "local485"
type: "ON/OFF"

*/



function MacroSelect(props){


  return (<select key={"OS-"+props.button+"-"+props.type} value={props.current} onChange={(e)=>props.callback(e,props.button,props.type)}>
    <option value="">None</option>
      {props.data.enum.map((d,i) =><option value={d} key={d}>{props.data.enumNames[i]}</option>)}
    </select>)



}


function macroName(name,macros){

  if (name.length==0){
    return "---"
  }
  try{
    return macros[name].name
  }
  catch(err){
    return name+" (Not found)"
  }
  return name+" (Not found)"
}


class OutStationButton extends Component{
  constructor(props) {
    super(props);
    this.state = {
      outEdit:false,
    };
  }



  render(){
    let buttons_actions=Object.keys(this.props.data)

    return (<tr key={"BUTTAB"+this.props.id}>
  {Object.keys(this.props.data).map((l,i) =><td  id={l} ><b>{l}</b>:{macroName(this.props.data[l],this.props.macros)}</td>)}
    </tr>)
  }
}
/*
<td><b>TAP:</b>{macroName(this.props.data.TAP,this.props.macros)}</td>
<td><b>DOUBLE TAP:</b>{macroName(this.props.data.DTAP,this.props.macros)}</td>
<td><b>HELD:</b>{macroName(this.props.data.HELD,this.props.macros)}</td>
<td><b>RELEASED:</b>{macroName(this.props.data.RELEASED,this.props.macros)}
*/


export default class OutStation extends Component {
    constructor(props) {
      super(props);
      this.state = {
        initialName:props.data.name,
        outEdit:false,
        macroList:{"enum": [], "enumNames": []},
        initalButtons:{}

      };

    }

    componentWillMount() {

      let temp=JSON.stringify(this.props.data.buttons)

    this.setState({initalButtons:JSON.parse(temp)})

    let macrolist=this.state.macroList
    //console.log(this.props.macros)
    for (var key in this.props.macros){
      macrolist.enum.push(key)
      macrolist.enumNames.push(this.props.macros[key].name)
    }

    this.setState({macroList:macrolist})

  }


  toggleAlert=()=>{

    console.log("Alert Toggle")
    this.setState({rgbAlert:!this.state.rgbAlert})
  }

editOutName=()=>{
  let temp=JSON.stringify(this.props.data.buttons)

  this.setState({initalButtons:JSON.parse(temp)})


    this.setState({outEdit:true})
}
saveOutputName=()=>{

  console.log(this.state.initialName)

  let data=this.props.data
  data["name"]=this.state.initialName
  data["buttons"]=this.state.initalButtons


  let d={
    cmd:"outstation",
    type:"update",
    id:this.props.id,
    data:data
  }
  console.log(d)
  this.props.callback(d)
  this.setState({outEdit:false})
}

closeOutputName=()=>{
this.setState({outEdit:false})

}

changeName=(e)=>{
  this.setState({initialName:e.target.value})
}

assignButton=(e,button,pressType)=>{

  console.log(button)
  console.log(pressType)

  let initalButtonsTemp=this.state.initalButtons
  initalButtonsTemp[button][pressType]=e.target.value
  this.setState({initalButtons:initalButtonsTemp})
console.log(e.target.value)





}


    render(){
      return <Well bsSize="small" key={"OB"+this.props.id}>
      {this.state.outEdit ? (
        <div>
        <input value={this.state.initialName} onChange={this.changeName}></input>
        <Button onClick={()=>this.saveOutputName()}>Save</Button><Button onClick={()=>this.closeOutputName()}>Cancel</Button>
          {Object.keys(this.state.initalButtons).map((l,i) =>
<span><h5>Button {l}</h5>
{Object.keys(this.state.initalButtons[l]).map((b,i) =><div key={"b"+l+"T"+b}><b>{b}</b><MacroSelect key={l+"-"+b} data={this.state.macroList} current={this.state.initalButtons[l][b]} callback={this.assignButton} button={l} type={b}></MacroSelect></div>)}
</span>
)}




        </div>
      ):(
        <div>
        <h4>{this.props.data.name}&nbsp;<Glyphicon onClick={()=>this.editOutName()} title="Edit name" className="iconBut" glyph="pencil" /> {this.props.key}</h4>
<table width="100%">
<tbody>
  {Object.keys(this.props.data.buttons).map((l,i) =><OutStationButton key={"BB"+i} id={i+"-"+l} button={l} macros={this.props.macros} data={this.props.data.buttons[l]} ></OutStationButton>)}
  </tbody>
</table>




      </div>)
      }
      </Well>





    }
}



// WEBPACK FOOTER //
// ./src/programmerComponents/OutStations.js